'use strict';

import axios from 'axios';
import { Loader } from '@googlemaps/js-api-loader';

let cachedPromise = null;

const fetchGoogleMapsData = async () => {
  const response = await axios.post(
    globalVariables.endpoint.getGoogleMapsAutocompleteData
  );

  if (response.status !== 200) {
    console.error('Error getting Google Maps Autocomplete data');
    return;
  }

  const { data } = response;
  const { apiKey = null, language = null, countryCode = '' } = data;

  if (!apiKey || !language) {
    console.error('Missing Google Maps Autocomplete data');
    return;
  }

  const loader = new Loader({
    apiKey: apiKey,
    version: 'weekly',
    language: language
  });

  return {
    loader: loader,
    language: language,
    countryCode: countryCode
  };
};

const initGoogleMapsAutocomplete = async () => {
  if (!cachedPromise) {
    cachedPromise = fetchGoogleMapsData().catch((error) => {
      cachedPromise = null;
      throw error;
    });
  }

  return cachedPromise;
};

export { initGoogleMapsAutocomplete };
